// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__13P4Z","alert":"SettungsInbox_alert__3PJao"};